import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import {
  Button,
  Dropdown,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Manifest } from 'services/action';

import { Skeletons } from 'ui/components/skeleton';
import { FormAdditional } from '../form/form.additional';
import { FormUpdatePartial } from '../form/form.update_partial'
import { Select } from 'ui/components';

import PDFManifest from 'ui/screens/authorized/pdf/manifest';
import { FormAir, FormLand, FormSea } from '../../form';
import { UTCFormat } from 'utilities/common';
import { toast } from 'react-toastify';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;

const initialState = {
  logo: null,
  moda_type: null,
  moda: null,
  vendor: null,
  showDelete: false,
  showPublish: false,
  showUnpublish: false,
  showAdditional: false,
  showStart: false,
  showModa: false,
  showVendor: false,
  showUpdatePartial: false
};

const modaOptions = [
  {
    value: 'land_freight',
    label: 'Darat',
  },
  {
    value: 'sea_freight',
    label: 'Laut',
  },
  {
    value: 'air_freight',
    label: 'Udara',
  },
];

export const Action = ({
  data,
  onSubmit,
  privilege,
  orderTrucking,
  reloadOrder,
}) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );

  const textCopierRef = React.useRef(null);

  const [
    {
      showUpdatePartial,
      showDelete,
      showPublish,
      showUnpublish,
      showAdditional,
      showStart,
      showModa,
      showVendor,
      moda_type,
      moda,
      vendor,
    },
    setState,
  ] = React.useState(initialState);

  const copyPODLink = () => {
    textCopierRef.current.select();
    document.execCommand('copy');

    toast.info('link e-manifest ter-copy', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
    });
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showUpdatePartial: false,
      showDelete: false,
      showAdditional: false,
      showPublish: false,
      showUnpublish: false,
      showStart: false,
      showModa: false,
      showVendor: false,
    }));
  };

  const $handlePublish = async () => {
    const req = await Dispatch(Manifest.$publish(data?.id));

    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  const $handleUnpublish = async () => {
    const req = await Dispatch(Manifest.$unpublish(data?.id));

    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  const $handleStart = async () => {
    const req = await Dispatch(Manifest.$start(data?.id));

    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Manifest.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();

      if (orderTrucking) {
        reloadOrder();
      } else {
        History.replace('/manifest');
      }
    }
  };

  const $handleModaChanges = (e) => {
    setState((prevState) => ({ ...prevState, moda_type: e }));
  };

  const $handleModaChange = (v) => {
    setState((prevState) => ({ ...prevState, moda: v }));
  };

  const $handleSubmit = async () => {
    const payload = {
      moda_type: moda_type?.value,
    };

    if (moda_type?.value === 'land_freight') {
      payload.land_freight = {
        driver_id: moda?.driver_id,
        vehicle_id: moda?.vehicle_id,
        vehicle_type_id: moda?.vehicle_type_id,
        name: moda?.name,
        phone_number: moda?.phone_number,
        vehicle_number: moda?.vehicle_number,
        bank_account: moda?.bank_account,
      };
    }

    if (moda_type?.value === 'air_freight') {
      payload.air_freight = {
        airplane: moda?.airplane,
        code_smu: moda?.code_smu,
        date: UTCFormat(moda?.date?.formatted, moda?.date_time, true),
        etd: UTCFormat(moda?.etd?.formatted, moda?.etd_time, true),
        no_manifest: moda?.no_manifest,
      };
    }

    if (moda_type?.value === 'sea_freight') {
      payload.sea_freight = {
        bl_code: moda?.bl_code,
        no_container: moda?.no_container,
        no_vessel: moda?.no_vessel,
      };
    }

    const req = await Dispatch(Manifest.$moda(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  const $handleChangeVendor = async () => {
    const payload = {
      vendor_id: vendor?.id,
    };

    const req = await Dispatch(Manifest.$vendor(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  React.useEffect(async () => {
    const toDataURL = (url) =>
      fetch(url, {
        headers: { 'Cache-Control': 'no-cache' },
      })
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    if (Session?.client?.avatar) {
      toDataURL(Session?.client?.avatar).then((dataUrl) => {
        setState((prevState) => ({ ...prevState, logo: dataUrl }));
      });
    }
  }, []);

  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const StandardAction = () => {
    return privilege
      ? data?.status === 'new' && (
          <>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
            >
              <Link
                to={`/manifest/${data?.id}/update`}
                className={cn('btn btn-primary px-2')}
              >
                <Fi.FiEdit size="17" />
              </Link>
            </OverlayTrigger>

            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
            >
              <button
                className={cn('btn btn-danger px-2')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showDelete: true }))
                }
              >
                <Fi.FiTrash2 size="17" />
              </button>
            </OverlayTrigger>
          </>
        )
      : null;
  };

  const SettingAction = () => {
    return privilege && data?.status !== 'completed' ? (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Pengaturan</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiSettings size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0 rounded-2">
          {data?.status !== 'completed' && data?.status !== 'new' && data?.type !== 'forwarder' && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  border-bottom"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showModa: true }))
              }
            >
              <Fi.FiEdit3 size={15} color="#202020" className="me-2" />
              Ganti Moda
            </div>
          )}

          {data?.status === 'new' && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  border-bottom"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showVendor: true }))
              }
            >
              <Fi.FiEdit3 size={15} color="#202020" className="me-2" />
              Ganti Vendor
            </div>
          )}

          {data?.status !== 'new' && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  border-bottom"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showAdditional: true,
                }))
              }
            >
              <Fi.FiPlus size={15} color="#202020" className="me-2" />
              Tambah Harga
            </div>
          )}

          {data?.type !== 'forwarder' && data?.status !== 'new' && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  border-bottom"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showUpdatePartial: true,
                }))
              }
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Perbaharui
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    ) : null;
  };

  const PrintAction = () => {
    return privilege ? (
      <Dropdown
        className="d-inline p-0 m-0 split-carret"
        as="div"
        align="end"
      >
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0 justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Print Manifest</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiPrinter size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0 rounded-2">
          <PDFManifest data={data} logo={Session?.client?.avatar} />

          <Link
            to={`/print/manifest/${data?.id}`}
            className="dropdown-item d-flex align-items-center cursor-pointer  "
            target="_blank"
          >
            <Fi.FiPrinter size={15} color="#202020" className="me-2" />
              Print Manifest
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    ) : null
  }

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          {data?.forwarder_id === '' && (
            <StandardAction />
          )}

          {data?.status !== 'new' && data?.type !== 'forwarder' ? (
            <>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-top`}>E-Manifest</Tooltip>}
              >
                <button
                  onClick={() => copyPODLink()}
                  className="btn btn-secondary px-2"
                >
                  <Fi.FiPaperclip size="17" />
                  <textarea
                    ref={textCopierRef}
                    style={{
                      height: 0,
                      width: 0,
                      resize: 'none',
                      position: 'absolute',
                      top: -1000,
                    }}
                    readOnly
                    value={`${POD_URL}/manifest/${data?.id}`}
                  />
                </button>
              </OverlayTrigger>
            </>
          ) : null}

          {data?.status !== 'new' && <PrintAction/>}

          {data?.status !== 'completed' && privilege && <SettingAction />}

          {data?.status === 'new' && data?.forwarder_id === '' && privilege && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Terbitkan Manifest</Tooltip>}
            >
              <button
                className={cn('btn btn-primary px-2 fs-8')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showPublish: true }))
                }
                style={{ height: 33 }}
              >
                Terbitkan Manifest
              </button>
            </OverlayTrigger>
          )}
          {data?.status === 'published' && data?.forwarder_id === '' && privilege && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`tooltip-top`}>Batal Terbit Manifest</Tooltip>}
            >
              <button
                className={cn('btn btn-danger px-2 fs-8')}
                onClick={() =>
                  setState((prevState) => ({ ...prevState, showUnpublish: true }))
                }
                style={{ height: 33 }}
              >
                Batal Terbit Manifest
              </button>
            </OverlayTrigger>
          )}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal publish */}
      <Modal
        show={showPublish}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handlePublish}
                disabled={StateForm?.loading}
              >
                Terbitkan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal unpublish */}
      <Modal
        show={showUnpublish}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleUnpublish}
                disabled={StateForm?.loading}
              >
                Batalkan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal start */}
      <Modal
        show={showStart}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleStart}
                disabled={StateForm?.loading}
              >
                Start
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal tambahan harga */}
      <Modal
        show={showAdditional}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Biaya Tambahan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormAdditional
            id={data?.id}
            onSubmit={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* modal update partial */}
      <Modal
        show={showUpdatePartial}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Manifest</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormUpdatePartial
            data={data}
            onSubmit={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* modal ganti moda */}
      <Modal
        show={showModa}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Ganti Moda</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fs-8 required">Moda</label>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.moda_type ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={moda_type}
              options={modaOptions}
              onChange={$handleModaChanges}
            />

            {StateForm?.errors?.moda_type ? (
              <div className="invalid-feedback d-block ">
                {StateForm?.errors?.moda_type}
              </div>
            ) : null}
          </div>

          {moda_type?.value === 'land_freight' && (
            <div className="col-md-12 mb-3">
              <FormLand removePadding onValueChange={$handleModaChange} />
            </div>
          )}

          {moda_type?.value === 'sea_freight' && (
            <div className="col-md-12 mb-3">
              <FormSea removePadding onValueChange={$handleModaChange} />
            </div>
          )}

          {moda_type?.value === 'air_freight' && (
            <div className="col-md-12 mb-3">
              <FormAir removePadding onValueChange={$handleModaChange} />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'mt-3 btn btn-primary py-1'
              )}
              disabled={StateForm?.loading}
              onClick={$handleSubmit}
            >
              Simpan
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal ganti vendor */}
      <Modal
        show={showVendor}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Ganti Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Select.Remote
              label="Pilih Vendor"
              placeholder=""
              url="/partner"
              params={{'type': 'vendor'}}
              value={vendor}
              initialValue={vendor?.id}
              keys={vendor?.id}
              row={(d) => {
                return {
                  value: d.id,
                  label: d.name,
                };
              }}
              onSelected={(c) => {
                setState((prevState) => ({
                  ...prevState,
                  vendor: c,
                }));
              }}
              errors={StateForm?.errors?.vendor_id}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button
              type="button"
              className={cn(
                StateForm?.loading ? 'btn-loading' : '',
                'mt-3 btn btn-primary py-1'
              )}
              disabled={StateForm?.loading}
              onClick={$handleChangeVendor}
            >
              Simpan
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
